import React, { PureComponent, Fragment } from "react";
import { Link } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import Cookies from "universal-cookie";
import axios from "axios";
import ReconnectingWebSocket from "reconnecting-websocket";
import Button from "@material-ui/core/Button/Button";
import { CSVLink, CSVDownload } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../components/footer/Footer";
import Messages from "../../components/messages/Messages";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import CityDetail from "../../components/city-detail/CityDetail";

import "./CityControlPanel.scss";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import { withRouter } from "react-router-dom";
import { inRange } from "lodash";

class CityControlPanel extends PureComponent {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.cookies = new Cookies();
    this.token = this.cookies.get("token");
    this.origin = this.cookies.get("origin");
    this.eventSource = null;
    this.delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.worldEventSource = null;
    this.ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
    this.socket = null;

    this.state = {
      city: {},
      cityCurrent: [],
      cityCurrentCSV: [["order", "metric", "value"]],
      creation_info: "",
      configurations: {},
      scenarioSelected: "",
      snackMsg: "Welcome!",
      snackOpen: false,
      snackType: "snack-success",
      snackAutoHideDuration: null,
      startRequestSent: false,
      advanceRequestSent: false,
      resetRequestSent: false,
      participants: [],
      roleLogout: "null",
      eventSourceMessage: [],
      requestLogoutSent: false,
      engagePass: "12345",
      engageOk: false,
      navLinks: [
        // {
        //   name: "Cities Management",
        //   href: "/instructor",
        //   icon: "iconInfo",
        //   target: "_self"
        // },
        // {
        //   name: "Frank Batten School",
        //   href: "https://batten.virginia.edu",
        //   icon: "iconBatten",
        //   target: "_blank",
        // },
        // {
        //   name: "CLSG",
        //   href: "https://www.clsgbatten.org",
        //   icon: "iconClsg",
        //   target: "_blank",
        // },
        {
          href: "https://dms.academy/",
          icon: "iconDMS",
          target: "_blank",
        },
      ],
      cityLinks: [
        {
          name: "Cities Management",
          href: "/instructor",
          icon: "iconInfo",
          target: "_self",
        },
      ],
      metricsJSON: "",
      metricsSelections: [],
      costSelections: [],
      revenueSelections: [],
      selectedMetric: "",
      combinedPlotData1: [],
      selectedPlotData1: [],
      selectedForecastPlotData1: [],
      plotType1: "",
      inDashboard: null,
      advanceGameMessage: [],
      selectionAvailable: true,
      navWidth: -400,
    };
  }

  messageTemporary = async (time) => {
    // await this.delay(time);
    this.setState({
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    });
    // await this.delay(time + 1000);
    // this.setState({
    //   messageMessage: null,
    //   messageType: null,
    //   messageFunction: null
    // })
  };

  authUser = () => {
    // console.log("Inside Auth User")
    // console.log(this.token)
    axios
      .get(this.camsURL + "/api/auth/user", {
        headers: { Authorization: `Token ${this.token}` },
      })
      .then((response) => {
        // console.group("CityControlPanel:authUser");
        // console.log(response.data);
        // console.groupEnd();
        if (response.data.id) {
          this.fetchCityData();
        } else {
          window.location.replace("/");
        }
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace("/");
      });
  };

  authUserWithSkey = () => {
    const city_skey = window.location.pathname.split("/")[3];
    console.log(city_skey);
    axios
      .post(this.camsURL + "/api/v1/users/authenticate_by_skey/", {
        skey: city_skey,
      })
      .then((response) => {
        console.group("CityControlPanel:authUserBySkey");
        console.log(response.data);
        console.groupEnd();
        if (response.data.success) {
          console.log("User Authenticated");
          this.cookies.set("token", response.data.data, { maxAge: 86400 });
          this.token = response.data.data;
          this.authUser();
        } else {
          window.location.replace("/");
        }
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace("/");
      });
  };

  getServerEvents = () => {
    const city_skey = this.state.city.skey;
    const city_path =
      this.ws_scheme + "://transcity.dmsi-sims.com/citysocket/" + city_skey;
    // const city_path =
    //   this.ws_scheme + "://localhost:7000/citysocket/" + city_skey;
    this.socket = new ReconnectingWebSocket(city_path);
    this.socket.addEventListener("open", (e) => {
      console.log("ws opened", e);
    });
    this.socket.addEventListener("close", (e) => {
      console.log("ws closed", e);
    });
    this.socket.addEventListener("message", (e) => {
      console.log("ws message", e);
      const message = JSON.parse(e.data).message;
      const data = JSON.parse(e.data).data;
      console.log(message);
      if (message === "participant_list") {
        this.setState({
          participants: data,
        });
      }
      if (message === "forecast_data") {
        console.log("We have forecast Data!!!");
        console.log(data);
        this.setState({
          forecastJSON: data.city_metrics,
          remainingForecastAttempts: data.forecast_attempts,
          messageDivVisibility: "visible",
          messageMessage: "Forecast Data now available!!!",
          messageType: "Success",
        });

        sessionStorage.setItem(
          "ForecastData",
          JSON.stringify(data.city_metrics)
        );

        let metricsPlot;
        const plottype1 = sessionStorage.getItem("selectedPlot1");

        if (plottype1) {
          this.setState({
            selectedMetric1: plottype1,
          });
          for (let item in this.state.metricsJSON) {
            if (item === plottype1) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.metricsJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.metricsJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData1: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }

          for (let item in this.state.forecastJSON) {
            if (item === plottype1) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.forecastJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.forecastJSON[item][0].type
              // );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot);
              this.setState({
                selectedForecastPlotData1: newFormattedMetric,
                combinedPlotData1: metricsPlot.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData1", plottype1);
            }
          }
        }
      }
      if (message === "plot_data") {
        console.log("we have plotdata");

        sessionStorage.setItem(
          "current_year",
          JSON.parse(data.metrics_data.current_year) + 1
        );
        sessionStorage.setItem(
          "previous_year",
          JSON.parse(data.metrics_data.current_year)
        );

        console.log(JSON.parse(data.metrics_data.city_metrics));
        this.setState({
          // metricsSelections: Object.keys(
          //   JSON.parse(JSON.parse(e.data).plotData.metrics_data.city_metrics)
          // ),
          metricsJSON: JSON.parse(data.metrics_data.city_metrics),
          previousYear: JSON.parse(data.metrics_data.current_year),
          currentYear: JSON.parse(data.metrics_data.current_year) + 1,
          forecastJSON: null,
          combinedPlotData1: [],
          selectedForecastPlotData1: [],
          cityCurrent: [],
          cityCurrentCSV: [["order", "metric", "value"]],
        });

        for (let item in this.state.metricsJSON) {
          let currentObj = {};
          let currentcsvArr = [];
          if (this.state.metricsJSON[item][0].type === "citycurrent") {
            currentObj[item.replace(" Now", "")] = this.state.metricsJSON[item];
            let placeholder = [];
            placeholder.push(
              this.state.metricsJSON[item][0].order,
              item.replace(" Now", ""),
              this.state.metricsJSON[item][0].City
            );
            currentcsvArr.push(placeholder);
            this.setState({
              cityCurrent: this.state.cityCurrent.concat(currentObj),
              cityCurrentCSV: this.state.cityCurrentCSV.concat(currentcsvArr),
            });
          }
        }

        let metricsPlot;
        const plottype1 = sessionStorage.getItem("selectedPlot1");

        if (plottype1) {
          this.setState({
            selectedMetric1: plottype1,
          });
          for (let item in this.state.metricsJSON) {
            if (item === plottype1) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.metricsJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.metricsJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData1: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }

          for (let item in this.state.forecastJSON) {
            console.log(e.target.value);
            console.log(item);
            if (item === e.target.value) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.forecastJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.forecastJSON[item][0].type
              );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType1: "transportation",
                    });

                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );
                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot);
              this.setState({
                selectedForecastPlotData1: newFormattedMetric,
                combinedPlotData1: metricsPlot.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData1", plottype1);
            }
          }
        }
      }
    });
    this.socket.addEventListener("error", (e) => {
      console.log("ws error", e);
    });

    this.eventSource = new EventSource(
      this.fetchURL + "/" + city_skey + "/events/"
    );
    // console.log(this.eventSource);
    this.eventSource.onmessage = (e) => {
      // console.log("Inside events event source for participants:  " + e.data);
      this.setState({
        participants: JSON.parse(e.data).data,
      });
    };

    this.eventSource2 = new EventSource(
      this.fetchURL + "/" + city_skey + "/selections/"
    );
    this.eventSource2.onmessage = (e) => {
      //************____below listener for plots___************//
      //*******************************************************//

      if (JSON.parse(e.data).plotData) {
        console.log("I can haz plotdata");

        sessionStorage.setItem(
          "current_year",
          JSON.parse(JSON.parse(e.data).plotData.metrics_data.current_year) + 1
        );
        sessionStorage.setItem(
          "previous_year",
          JSON.parse(JSON.parse(e.data).plotData.metrics_data.current_year)
        );

        console.log(
          JSON.parse(JSON.parse(e.data).plotData.metrics_data.city_metrics)
        );
        this.setState({
          // metricsSelections: Object.keys(
          //   JSON.parse(JSON.parse(e.data).plotData.metrics_data.city_metrics)
          // ),
          metricsJSON: JSON.parse(
            JSON.parse(e.data).plotData.metrics_data.city_metrics
          ),
          previousYear: JSON.parse(
            JSON.parse(e.data).plotData.metrics_data.current_year
          ),
          currentYear:
            JSON.parse(JSON.parse(e.data).plotData.metrics_data.current_year) +
            1,
          forecastJSON: null,
          combinedPlotData1: [],
          selectedForecastPlotData1: [],
          cityCurrent: [],
          cityCurrentCSV: [["order", "metric", "value"]],
        });

        for (let item in this.state.metricsJSON) {
          let currentObj = {};
          let currentcsvArr = [];
          if (this.state.metricsJSON[item][0].type === "citycurrent") {
            currentObj[item.replace(" Now", "")] = this.state.metricsJSON[item];
            let placeholder = [];
            placeholder.push(
              this.state.metricsJSON[item][0].order,
              item.replace(" Now", ""),
              this.state.metricsJSON[item][0].City
            );
            currentcsvArr.push(placeholder);
            this.setState({
              cityCurrent: this.state.cityCurrent.concat(currentObj),
              cityCurrentCSV: this.state.cityCurrentCSV.concat(currentcsvArr),
            });
          }
        }

        let metricsPlot;
        const plottype1 = sessionStorage.getItem("selectedPlot1");

        if (plottype1) {
          this.setState({
            selectedMetric1: plottype1,
          });
          for (let item in this.state.metricsJSON) {
            if (item === plottype1) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.metricsJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.metricsJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData1: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }

          for (let item in this.state.forecastJSON) {
            console.log(e.target.value);
            console.log(item);
            if (item === e.target.value) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.forecastJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.forecastJSON[item][0].type
              );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType1: "transportation",
                    });

                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );
                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot);
              this.setState({
                selectedForecastPlotData1: newFormattedMetric,
                combinedPlotData1: metricsPlot.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData1", plottype1);
            }
          }
        }

        this.eventSource.onerror = (e) => {
          console.log(
            "The onerror listener fired due to lost connection.  Use this function to recall the metrics from the back end"
          );
          console.log(e);
          // this.fetchCityMetrics()
          // this.fetchPolicies()
          window.location.reload(true);
        };
      }
    };
  };

  fetchCityMetrics = (city_skey) => {
    // console.log("Inside FetchCityMetrics:  " + city_skey);
    this.setState({ selectionAvailable: false });
    axios
      .get(this.fetchURL + "/api/v1/city_metrics/", {
        params: { city_skey: city_skey },
      })
      .then((response) => {
        // console.log(response.data);
        if (response.data.success) {
          // console.log(
          //   "Fetching City Metrics from Back End...(metrics data)...:  ",
          //   JSON.parse(response.data.data.city.city_metrics)
          // );

          this.setState({
            metricsJSON: JSON.parse(response.data.data.city.city_metrics),
            currentYear: JSON.parse(response.data.data.city.current_year) + 1,
            previousYear: JSON.parse(response.data.data.city.current_year),
            remainingForecastAttempts: JSON.parse(
              response.data.data.city.forecast_attempts
            ),
          });
          let metricArr = [];
          let costArr = [];
          let revArr = [];
          for (let item in JSON.parse(response.data.data.city.city_metrics)) {
            //--Parking Value

            if ([item] === "District Road And Parking Portion Now") {
              console.log(
                JSON.parse(response.data.data.city.city_metrics)[item][0]
              );
              this.setState({
                parkingZone: JSON.parse(response.data.data.city.city_metrics)[
                  item
                ][0],
              });
            }
            //---Non Cost Metrics
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcostcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycostscurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtparkingcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcost" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycost" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "cityrevenuecurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "cityrevenue" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtrevenuecurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtrevenue" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycurrent"
            ) {
              metricArr.push(item);
              // console.log(metricArr)
              metricArr.sort();

              this.setState({
                metricsSelections: metricArr,
              });
            }
            //--Cost Metrics
            if (
              (JSON.parse(response.data.data.city.city_metrics)[item][0]
                .type === "districtcost" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "citycost") &&
              !JSON.parse(response.data.data.city.city_metrics)[item][0]
                .category
            ) {
              costArr.push(item);
              // console.log(costArr)
              costArr.sort();

              this.setState({
                costSelections: costArr,
              });
            }
            if (
              (JSON.parse(response.data.data.city.city_metrics)[item][0]
                .type === "districtrevenue" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "cityrevenue") &&
              !JSON.parse(response.data.data.city.city_metrics)[item][0]
                .category
            ) {
              revArr.push(item);
              // console.log(revArr)
              revArr.sort();

              this.setState({
                revenueSelections: revArr,
              });
            }

            let currentObj = {};
            let currentcsvArr = [];
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
              "citycurrent"
            ) {
              currentObj[item.replace(" Now", "")] = JSON.parse(
                response.data.data.city.city_metrics
              )[item];
              let placeholder = [];
              placeholder.push(
                JSON.parse(response.data.data.city.city_metrics)[item][0].order,
                item.replace(" Now", ""),
                JSON.parse(response.data.data.city.city_metrics)[item][0].City
              );
              currentcsvArr.push(placeholder);
              this.setState({
                cityCurrent: this.state.cityCurrent.concat(currentObj),
                cityCurrentCSV: this.state.cityCurrentCSV.concat(currentcsvArr),
              });
            }

            this.setState({ selectionAvailable: true });
          }
          sessionStorage.setItem(
            "current_year",
            JSON.parse(response.data.data.city.current_year) + 1
          );
          sessionStorage.setItem(
            "previous_year",
            JSON.parse(response.data.data.city.current_year)
          );
        }
        console.groupEnd();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchCityData = () => {
    const city_skey = window.location.pathname.split("/")[3];

    axios
      .all([
        axios.get(this.fetchURL + "/api/v1/cities/", {
          params: { city_skey: city_skey },
          headers: { Authorization: `Token ${this.token}` },
        }),
        axios.get(this.fetchURL + "/api/v1/cities/configurations/", {
          headers: { Authorization: `Token ${this.token}` },
        }),
      ])
      .then(
        axios.spread((cityResponse, configResponse) => {
          // console.group("CityControlPanel:fetchCityData");
          // console.log(cityResponse);
          // console.log(configResponse);
          // console.groupEnd();
          if (cityResponse.data.success) {
            let info = cityResponse.data.data;
            this.setState({
              city: info.city,
              creation_info: info.creation_info,
              scenarioSelected: info.city.config_number,
            });
            this.getServerEvents();
            this.fetchParticipants();
            this.fetchCityMetrics(info.city.skey);
          }

          if (configResponse.data.success) {
            let configs = configResponse.data.data;
            this.setState({ configurations: configs });
          }
        })
      )
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchParticipants = () => {
    axios
      //   .get(this.fetchURL + "/api/v1/roles/status/", {
      .get(this.fetchURL + "/api/v1/participants/", {
        params: { city_skey: this.state.city.skey },
        headers: { Authorization: `Token ${this.token}` },

        // params: { city_id: this.state.city.id },
        // headers: { Authorization: `Token ${this.token}` }
      })
      .then((response) => {
        // console.group("CityControlPanel:fetchParticipants");
        // console.log(response.data);
        // console.groupEnd();
        const participants = response.data.data;
        this.setState({ participants: participants });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  updateStatus = (e, cityId) => {
    e.preventDefault();

    axios
      .put(
        this.fetchURL + "/api/v1/cities/",
        {
          city_id: cityId,
          is_active: !this.state.city.is_active,
        },
        { headers: { Authorization: `Token ${this.token}` } }
      )
      .then((response) => {
        if (response.data.success) {
          console.group("CityControlPanel:updateStatus");
          console.log("Game status Updated!");
          console.groupEnd();

          this.setState((prevState) => ({
            city: Object.assign({}, prevState.city, {
              is_active: !prevState.city.is_active,
            }),
            snackOpen: true,
            snackMsg: "Game status Updated.",
            snackType: "snack-success",
            snackAutoHideDuration: 5000,
          }));
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
          snackAutoHideDuration: 5000,
        });
      });
  };

  preventAdvance = (e) => {
    e.preventDefault();

    let id = e.target.getAttribute("id");
    let name = e.target.getAttribute("name");
    let skey = e.target.getAttribute("skey");

    this.setState({
      // snackType: "snack-advance",
      // snackOpen: true,
      // snackMsg: "Are you sure you want to advance the game?",
      messageDivVisibility: "visible",
      messageMessage:
        'Please double check the "current year". Are you sure you want to advance the game?',
      messageType: "Warning",
      messageFunction: "Advance",
      advanceId: id,
      advanceName: name,
      advanceSkey: skey,
    });
  };

  preventEngagementReset = (e) => {
    e.preventDefault();
    this.setState({
      // snackType: "snack-advance",
      // snackOpen: true,
      // snackMsg: "Are you sure you want to advance the game?",
      messageDivVisibility: "visible",
      messageMessage: "Please input your secret CLSG password.",
      messageType: "Warning",
      messageFunction: "resetEngagement",
      engagementResetId: this.state.city.id,
    });
  };

  preventCityReset = (e) => {
    e.preventDefault();

    this.setState({
      // snackType: "snack-advance",
      // snackOpen: true,
      // snackMsg: "Are you sure you want to advance the game?",
      messageDivVisibility: "visible",
      messageMessage:
        "Are you sure you want to reset your city and start over?",
      messageType: "Warning",
      messageFunction: "resetCity",
      resetId: this.state.city.id,
      resetName: this.state.city.city_name,
      resetSkey: this.state.city.skey,
    });
  };

  passInput = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
    });
    if (value === this.state.engagePass) {
      this.setState({
        engageOk: true,
      });
    } else {
      this.setState({
        engageOk: false,
      });
    }
  };

  advanceGame = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
    this.setState({
      advanceGameMessage: "Advancing...",
    });
    let id = e.target.getAttribute("id");
    let name = e.target.getAttribute("name");
    let skey = e.target.getAttribute("skey");
    console.log(name);
    this.setState({
      advanceGameMessage: this.state.advanceGameMessage.concat(parseInt(id)),
    });

    axios
      .post(
        this.fetchURL + "/api/v1/cities/advance/",
        {
          city_id: id,
          city_name: name,
          city_skey: skey,
        },
        {
          headers: {
            Authorization: `Token ${this.token}`,
          },
        }
      )
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.group("Policy Advance Test Test");
          console.log("Test Successfull!");
          // this.updateStatus();
          console.log(response.data.data);
          let info = response.data.data;
          this.setState({
            city: info,
          });
          console.groupEnd();
          let advancedGameMessageArr = [...this.state.advanceGameMessage];
          var index = advancedGameMessageArr.indexOf(
            parseInt(response.data.data.id)
          );
          if (index !== -1) {
            advancedGameMessageArr.splice(index, 1);
          }
          this.messageTemporary(500);
          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-success",
            // snackAutoHideDuration: 5000,
            advanceGameMessage: advancedGameMessageArr,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Success",
          });
        } else {
          let advancedGameMessageArr = [...this.state.advanceGameMessage];
          var indexForError = advancedGameMessageArr.indexOf(parseInt(id));
          if (indexForError !== -1) {
            advancedGameMessageArr.splice(indexForError, 1);
          }

          console.log(response.data.message);
          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-error",
            // snackAutoHideDuration: 5000,
            advanceGameMessage: advancedGameMessageArr,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Error",
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          // snackOpen: true,
          // snackMsg: "Something went wrong. Please try again later.",
          // snackType: "snack-error",
          // snackAutoHideDuration: 5000,
          // advanceGameMessage: null,
          messageDivVisibility: "visible",
          messageMessage: "Network Error, please make your selection again.",
          messageType: "Error",
        });
      });
    console.groupEnd();
  };

  componentDidMount = () => {
    const origin = window.location.pathname.split("/")[4];
    if (origin) {
      this.cookies.set("origin", origin, { maxAge: 86400 });
      this.origin = origin;
    } else {
      this.cookies.set("origin", "NOT_CLSG", { maxAge: 86400 });
      this.origin = "NOT_CLSG";
    }
    if (origin !== "CLSG") {
      this.authUser();
      this.setState({
        inDashboard: true,
      });
    } else {
      console.log("User is from CLSG attempting to get token from backend...");
      this.authUserWithSkey();
    }
  };

  componentWillUnmount = () => {
    if (this.eventSource) {
      this.eventSource.close();
    }

    if (this.eventSource2) {
      this.eventSource2.close();
    }
    if (this.socket) {
      this.socket.close();
    }
  };

  pollingFunctions = () => {
    this.fetchParticipants();
  };

  onNavLinkClick = (e, nav) => {
    e.preventDefault();

    if (nav.target === "_self") {
      this.props.history.push(nav.href);
    } else if (nav.target === "_blank") {
      window.open(nav.href, "_blank");
    }
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  startScenario = (e) => {
    e.preventDefault();
    this.setState({
      snackType: "snack-start",
      snackOpen: true,
      snackMsg:
        "Are all roles logged in? Do you want to start scenario " +
        this.state.scenarioSelected.toString() +
        "?",
    });
  };

  startScenarioYes = () => {
    this.setState({ startRequestSent: true });
    this.handleClose();
    console.group("CityControlPanel:startScenarioYes");
    console.log("Starting scenario confirmed!");

    axios
      .post(
        this.fetchURL + "/api/v1/cities/games/",
        {
          city_id: this.state.city.id,
          config_number: this.state.scenarioSelected,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.group("CityControlPanel:startScenario");
          console.log("City Initialized!");
          console.log(response.data.data);
          console.groupEnd();
          let info = response.data.data;

          this.setState({
            city: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-success",
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after starting the scenario
          // window.location.reload();
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: null,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
          snackAutoHideDuration: 5000,
        });
      });
    console.groupEnd();
  };

  // advanceScenario = e => {
  //   e.preventDefault();
  //   this.setState({
  //     snackType: "snack-advance",
  //     snackOpen: true,
  //     snackMsg:
  //       "Do you want to advance scenario " +
  //       this.state.scenarioSelected.toString() +
  //       "?"
  //   });
  // };

  advanceScenarioYes = () => {
    this.setState({ advanceRequestSent: true });
    this.handleClose();
    console.group("CityControlPanel:advanceScenarioYes");
    console.log("Advancing scenario confirmed!");

    axios
      .post(
        this.fetchURL + "/api/v1/cities/advance/",
        {
          city_id: this.state.city.skey,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
          timeout: 300000,
        }
      )
      .then((response) => {
        this.setState({ advanceRequestSent: false });
        if (response.data.success) {
          console.group("CityControlPanel:cityAdvance");
          console.log("City Advanced!");
          console.log(response.data.data);
          console.groupEnd();
          let info = response.data.data;

          this.setState({
            city: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-success",
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after advance
          // window.location.reload();
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ advanceRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
          snackAutoHideDuration: 5000,
        });
      });
    console.groupEnd();
  };

  resetScenario = (e) => {
    e.preventDefault();
    this.setState({
      snackType: "snack-reset",
      snackOpen: true,
      snackMsg:
        "Do you want to reset scenario " +
        this.state.scenarioSelected.toString() +
        "?",
    });
  };

  resetScenarioYes = () => {
    this.setState({ resetRequestSent: true });
    this.handleClose();
    console.group("CityControlPanel:resetScenarioYes");
    console.log("Resetting scenario confirmed!");

    // axios.delete(this.fetchURL + '/api/v1/worlds/games/', {
    //     params: {city_id: this.state.city.id,},
    //     headers: {Authorization: `Token ${this.token}`},
    // })

    axios
      .delete(this.fetchURL + "/api/v1/cities/games/", {
        params: {
          data:
            this.state.city.id.toString() +
            "_" +
            this.state.scenarioSelected.toString(),
        },
        headers: { Authorization: `Token ${this.token}` },
      })

      .then((response) => {
        this.setState({ resetRequestSent: false });
        if (response.data.success) {
          console.group("CityControlPanel:resetScenario");
          console.log("City Reset!");
          console.log(response.data.data);
          console.groupEnd();
          let info = response.data.data;

          this.setState({
            city: info,
          });

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-success",
            snackAutoHideDuration: 5000,
          });

          // added to update objectives after resetting the scenario
          // but interfered with 'active' status, so commented out
          // window.location.reload();

          setTimeout(
            () =>
              window.location.replace("/instructor/city/" + info.skey + "/"),
            3000
          );
        } else {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ resetRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
          snackAutoHideDuration: 5000,
        });
      });
    console.groupEnd();
  };

  selectRole = (e) => {
    this.setState({ roleLogout: e.target.value });
  };

  logoutRole = (e) => {
    e.preventDefault();

    if (this.state.roleLogout !== "null") {
      const dropDown = document.getElementById("roleLogout");
      this.setState({
        snackType: "snack-logout",
        snackOpen: true,
        snackMsg: "Are you sure you want to leave?",
      });
    } else {
      this.setState({
        snackType: "snack-error",
        snackOpen: true,
        snackMsg: "Select a role to logout",
      });
    }
  };

  logoutPrevent = (e) => {
    e.preventDefault();
    if (this.origin === "CLSG") {
      this.setState({
        // snackType: "snack-logout",
        // snackOpen: true,
        // snackMsg: "Are you sure you want to leave?"
        messageDivVisibility: "visible",
        messageMessage:
          "Are you sure you want to return to your CLSG account page?",
        messageType: "Warning",
        messageFunction: "Logout",
      });
    }
    if (this.origin === "NOT_CLSG") {
      this.setState({
        // snackType: "snack-logout",
        // snackOpen: true,
        // snackMsg: "Are you sure you want to leave?"
        messageDivVisibility: "visible",
        messageMessage: "Are you sure you want to leave?",
        messageType: "Warning",
        messageFunction: "Logout",
      });
    }
  };

  logoutRoleYes = () => {
    this.setState({ requestLogoutSent: true });
    this.handleClose();
    console.group("CityControlPanel:logoutRoleYes");
    console.log("Logout role confirmed!");
    window.close();
    // axios
    //   .post(
    //     this.camsURL + "/api/v1/users/logout/",
    //     {},
    //     {
    //       headers: { Authorization: `Token ${this.token}` }
    //     }
    //   )
    //   .then(response => {
    //     this.setState({ requestLogoutSent: false });
    //     if (response.data.success) {
    //       console.group("CityControlPanel:logoutRoleYes");
    //       console.log(response.data);
    //       console.groupEnd();

    //       this.setState({
    //         snackOpen: true,
    //         snackMsg: `Logout successful!`,
    //         snackType: "snack-success",
    //         snackAutoHideDuration: 5000
    //       });

    //     } else {
    //       console.log(response.data.message);
    //       this.setState({
    //         snackOpen: true,
    //         snackMsg: response.data.message,
    //         snackType: "snack-error",
    //         snackAutoHideDuration: 5000
    //       });
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error.response);
    //     this.setState({ requestLogoutSent: false });
    //     this.setState({
    //       snackOpen: true,
    //       snackMsg: "Something went wrong. Please try again later.",
    //       snackType: "snack-error",
    //       snackAutoHideDuration: 5000
    //     });
    //   });
    console.groupEnd();
  };

  onRolesGridToggle = (e) => {
    let me = e.target;
    if (!me.classList.contains("wcp__plusSign")) {
      me = me.parentElement;
    }
    me.classList.toggle("is-open");

    let roleGrid = document.getElementById("roles-grid");
    roleGrid.classList.toggle("hide-grid");
  };

  // onObjectivesGridToggle = e => {
  //   let me = e.target;
  //   if (!me.classList.contains("wcp__plusSign")) {
  //     me = me.parentElement;
  //   }
  //   me.classList.toggle("is-open");

  //   let objectivesGrid = document.getElementById("objectives-grid");
  //   objectivesGrid.classList.toggle("hide-grid");
  // };

  logoutYes = (e) => {
    e.preventDefault();
    this.setState({ requestSent: true });
    if (this.origin === "CLSG") {
      window.close();
    }
    if (this.origin === "NOT_CLSG") {
      axios
        .post(
          this.camsURL + "/api/auth/logout",
          {},
          {
            headers: { Authorization: `Token ${this.token}` },
          }
        )
        .then((response) => {
          this.setState({ requestSent: false });

          if (response.status === 204 || response.status === 200) {
            this.setState({
              snackOpen: true,
              snackMsg: `Logout successful!`,
              snackType: "snack-success",
              snackAutoHideDuration: 5000,
            });
            this.cookies.remove("token");
            window.location.replace("/");
          } else {
            this.setState({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: "snack-error",
              snackAutoHideDuration: 5000,
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({ requestSent: false });
        });
    }
  };

  onPlotChange1 = (e) => {
    let metricsPlot;
    let testPlot;
    this.setState({
      combinedPlotData1: [],
      selectedPlotData1: [],
      selectedForecastPlotData1: [],
    });
    const { name, value } = e.target;

    if (e.target.value) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    console.log(this.state.forecastJSON);

    for (let item in this.state.metricsJSON) {
      if (item === e.target.value) {
        console.log(item);
        console.log(
          "After plot selection in onChange Function:  ",
          this.state.metricsJSON[item]
        );
        console.log(
          "Searching for type:  ",
          this.state.metricsJSON[item][0].type
        );
        let newFormattedMetric;

        if (this.state.metricsJSON[item]) {
          switch (this.state.metricsJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "district",
              });
              break;
            case "transportation":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                  "Forecasted Walk": item.walk,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted Car"];
                  delete item["Forecasted Rail"];
                  delete item["Forecasted Bus"];
                  delete item["Forecasted Bike"];
                  delete item["Forecasted Walk"];
                }
              });

              this.setState({
                plotType1: "transportation",
              });
              break;
            case "districtcost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                console.log(typeof item.year);
                console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "cityrevenue",
              });
              break;
          }
          console.log(newFormattedMetric);
        }
        this.setState({
          selectedPlotData1: newFormattedMetric,
        });
        metricsPlot = newFormattedMetric;
        testPlot = newFormattedMetric;
        sessionStorage.setItem("selectedPlot1", e.target.value);
      }
    }

    for (let item in this.state.forecastJSON) {
      console.log(e.target.value);
      console.log(item);
      if (item === e.target.value) {
        console.log(item);
        console.log(
          "After plot selection in onChange Function:  ",
          this.state.forecastJSON[item]
        );
        console.log(
          "Searching for type:  ",
          this.state.forecastJSON[item][0].type
        );

        let newFormattedMetric;

        if (this.state.forecastJSON[item]) {
          switch (this.state.forecastJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "district",
              });

              break;
            case "transportation":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Walk": item.Walk,
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Car);
              newFormattedMetric.forEach((item) => delete item.Rail);

              newFormattedMetric.forEach((item) => delete item.Bus);

              newFormattedMetric.forEach((item) => delete item.Bike);

              newFormattedMetric.forEach((item) => delete item.Walk);

              this.setState({
                plotType1: "transportation",
              });

              break;
            case "districtcost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "cityrevenue",
              });
              break;
          }
          console.log(newFormattedMetric);
        }

        console.log(metricsPlot);
        this.setState({
          selectedForecastPlotData1: newFormattedMetric,
          combinedPlotData1: metricsPlot.concat(newFormattedMetric),
        });
        sessionStorage.setItem("selectedForecastPlotData1", e.target.value);
        console.log(testPlot.concat(newFormattedMetric));
      }
    }
  };

  openNav = (e) => {
    e.preventDefault();
    console.log("opened");
    this.setState({
      navWidth: 0,
    });
  };

  closeNav = (e) => {
    console.log("closed");
    e.preventDefault();
    this.setState({
      navWidth: -400,
    });
  };

  closeMessage = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
  };

  resetEngagement = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
    let id = e.target.getAttribute("id");
    console.log("Engagement resetting...");
    axios
      .post(this.fetchURL + "/api/v1/cities/engagement_reset/", {
        city_id: id,
      })
      .then((response) => {
        if (response.data.success) {
          console.log("Engagement Reset.");
          this.setState({
            messageDivVisibility: "visible",
            messageMessage:
              "Engagement has been reset, please have team sign out and sign back in again.",
            messageType: "Success",
            engageOk: false,
          });
        } else {
          console.log(response.data.message);
          this.setState({
            messageDivVisibility: "visible",
            messageMessage: "Engagement was not properly reset.  Invalid Data.",
            messageType: "Error",
            engageOk: false,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          messageDivVisibility: "visible",
          messageMessage: "Network Error, please make your try again.",
          messageType: "Error",
          engageOk: false,
        });
      });
  };

  resetCity = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
    let id = e.target.getAttribute("id");
    let name = e.target.getAttribute("name");

    console.log("City resetting...");
    axios
      .post(this.fetchURL + "/api/v1/cities/reset/", {
        city_id: id,
        city_name: name,
        city_config: 1,
        city_skey: this.state.city.skey,
      })
      .then((response) => {
        if (response.data.success) {
          console.log("City Reset.");
          this.fetchCityData();
          this.setState({
            selectedMetric1: "",
            selectedPlotData1: [],
            selectedForecastPlotData1: [],
            combinedPlotData1: [],
            forecastJSON: "",
            messageDivVisibility: "visible",
            messageMessage:
              "The city has been reset, Please instruct students to select a new role.",
            messageType: "Success",
            engageOk: false,
          });
        } else {
          console.log(response.data.message);
          this.setState({
            messageDivVisibility: "visible",
            messageMessage: "The city was not properly reset.  Invalid Data.",
            messageType: "Error",
            engageOk: false,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          messageDivVisibility: "visible",
          messageMessage: "Network Error, please make your try again.",
          messageType: "Error",
          engageOk: false,
        });
      });
  };

  render() {
    let dynamicPlotData;
    if (this.state.combinedPlotData1.length > 1) {
      dynamicPlotData = this.state.combinedPlotData1;
    } else {
      dynamicPlotData = this.state.selectedPlotData1;
    }
    let plotColor = "slategray";
    const { city, creation_info } = this.state;
    return (
      <div>
        <Messages
          messageDivVisibility={this.state.messageDivVisibility}
          messageMessage={this.state.messageMessage}
          messageType={this.state.messageType}
          messageFunction={this.state.messageFunction}
          closeMessage={this.closeMessage}
          logoutYes={this.logoutYes}
          onDistrictSubmitHandler={this.onDistrictSubmitHandler}
          onCitySubmitHandler={this.onCitySubmitHandler}
          onEngagementSubmitHandler={this.onEngagementSubmitHandler}
          advanceId={this.state.advanceId}
          advanceName={this.state.advanceName}
          advanceSkey={this.state.advanceSkey}
          resetId={this.state.resetId}
          resetName={this.state.resetName}
          resetSkey={this.state.resetSkey}
          advanceGame={this.advanceGame}
          resetEngagement={this.resetEngagement}
          resetCity={this.resetCity}
          engagementResetId={this.state.engagementResetId}
          passInput={this.passInput}
          engageOk={this.state.engageOk}
        />
        {/* <div className="persistantBrand flex flex-50-50">
        {this.state.navLinks.map((item, index) => (
              <a key={index} href={item.href} target={item.target}><span className={item.icon}></span></a>
            ))}
        </div> */}

        {/* <div id="mySidenav" class="sidenav" style={{ right: `${this.state.navWidth}px` }}>
          <a href="javascript:void(0)" className="closebtn" onClick={e => this.closeNav(e)}>
            &times;
          </a>
          <div className="logoutDiv">
          <button className="logout" onClick={e => this.logoutPrevent(e)}>
              Logout
            </button>
            </div>
            <p>Resources</p>
            <hr />
          <a href="#">Glossary</a>
          <a href="#">References</a>
          <p>Links</p>
            <hr />
            {this.state.navLinks.map((item, index) => (
              <a key={index} href={item.href} target={item.target}>{item.name}{" "}<span className={item.icon}></span></a>
            ))}
        </div>
 */}
        <div className="instructorNav flex flex-auto">
          <div className="sudoLogo" />
          <div className="metroLogo" />
          {/* <h3 className="instructorRole">Instructor</h3> */}
          {/* <h1 className="instructorLogo">METRO</h1> */}
          <ul className="dashboardLink" style={{ marginLeft: "20px" }}>
            {this.state.cityLinks.map(
              (nav, index) =>
                this.origin === "NOT_CLSG" ? (
                  <li key={index}>
                    <Link
                      to={nav.href}
                      onClick={(e) => this.onNavLinkClick(e, nav)}
                      name={nav.name}
                    >
                      {nav.name}
                    </Link>
                  </li>
                ) : null
            )}
          </ul>
          <button
            className="logout"
            style={{ marginLeft: "auto" }}
            onClick={(e) => this.logoutPrevent(e)}
          >
            {this.origin === "CLSG" ? "Return to Account" : "Logout"}
          </button>
        </div>
        <div className="backgroundSignUp" />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackOpen}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          className={this.state.snackType}
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === "snack-start"
              ? [
                  <Button
                    key="yes"
                    color="inherit"
                    onClick={this.startScenarioYes}
                  >
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : this.state.snackType === "snack-reset"
                ? [
                    <Button
                      key="yes"
                      color="inherit"
                      onClick={this.resetScenarioYes}
                    >
                      Yes
                    </Button>,
                    <Button key="no" color="inherit" onClick={this.handleClose}>
                      No
                    </Button>,
                  ]
                : this.state.snackType === "snack-advance"
                  ? [
                      <Button
                        key="yes"
                        color="inherit"
                        onClick={this.advanceGame}
                      >
                        Yes
                      </Button>,
                      <Button
                        key="no"
                        color="inherit"
                        onClick={this.handleClose}
                      >
                        No
                      </Button>,
                    ]
                  : this.state.snackType === "snack-logout"
                    ? [
                        <Button
                          key="yes"
                          color="inherit"
                          onClick={this.logoutRoleYes}
                        >
                          Yes
                        </Button>,
                        <Button
                          key="no"
                          color="inherit"
                          onClick={this.handleClose}
                        >
                          No
                        </Button>,
                      ]
                    : []
          }
        />

        {/* <CountdownTimer
          time={INSTRUCTOR_POLL_TIME} */}
        {/* // cb={this.pollingFunctions} */}
        {/* /> */}
        {/* <div className="header__padding" /> */}
        {this.state.city &&
        Object.keys(this.state.configurations).length > 0 ? (
          // <div className="instructorDashDetail__wrap">
          // <div className="dash__outer">
          <Fragment>
            <ReactCSSTransitionGroup
              transitionName="fade"
              transitionAppear={true}
              transitionAppearTimeout={500}
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}
            >
              <CityDetail
                display={true}
                updateStatus={this.updateStatus}
                id={city.id}
                name={city.city_name}
                code={creation_info.game_code}
                skey={city.skey}
                purpose={creation_info.purpose}
                currYear={city.current_year}
                is_active={city.is_active}
                is_complete={city.is_complete}
                disableStatus={this.state.city.has_started}
                hideGoto={true}
                preventAdvance={this.preventAdvance}
                preventCityReset={this.preventCityReset}
                advanceGame={this.advanceGame}
                inDashboard={this.state.inDashboard}
                advanceGameMessage={this.state.advanceGameMessage}
              />
            </ReactCSSTransitionGroup>
            <ReactCSSTransitionGroup
              transitionName="fade"
              transitionAppear={true}
              transitionAppearTimeout={500}
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}
            >
              <div className="participantDiv">
                <div className="flex flex-justify-between">
                  <div className="flex">
                    {" "}
                    <h1>Participant List</h1>
                    <CSVLink
                      className="csvLink"
                      data={this.state.cityCurrentCSV}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "file-excel"]}
                        style={{ color: "#5399C9" }}
                      />
                    </CSVLink>
                  </div>
                  <div className="flex">
                    <button
                      className="cityReset"
                      onClick={this.preventCityReset}
                    >
                      City Reset
                    </button>
                    <button
                      className="engagementReset"
                      onClick={this.preventEngagementReset}
                    >
                      Engagement Reset
                    </button>
                    <h1>City Metrics</h1>
                  </div>
                </div>
                <hr />
                <div className="flex flex-50-50">
                  <div>
                    <table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Role</th>
                          <th>Logged In</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.participants
                          ? this.state.participants.map((item, index) => (
                              <tr key={index}>
                                <td>{item.participant_name}</td>
                                <td>{item.participant_email}</td>
                                <td>{item.participant_role}</td>
                                {item.participant_login_flag ? (
                                  <td>
                                    <div
                                      style={{
                                        backgroundColor: "green",
                                        borderRadius: "50px",
                                        height: "10px",
                                        width: "10px",
                                      }}
                                    />
                                  </td>
                                ) : (
                                  <td>
                                    <div
                                      style={{
                                        backgroundColor: "red",
                                        borderRadius: "50px",
                                        height: "10px",
                                        width: "10px",
                                      }}
                                    />
                                  </td>
                                )}
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                    <table>
                      <thead>
                        <tr>
                          <th>Metric</th>
                          <th>Current Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.cityCurrent.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={
                                Object.keys(item)
                                  .toString()
                                  .includes("Costs")
                                  ? { color: "red" }
                                  : Object.keys(item)
                                      .toString()
                                      .includes("Revenue")
                                    ? { color: "green" }
                                    : null
                              }
                            >
                              {Object.keys(item)}{" "}
                            </td>
                            <td
                              style={
                                Object.keys(item)
                                  .toString()
                                  .includes("Costs")
                                  ? { color: "red" }
                                  : Object.keys(item)
                                      .toString()
                                      .includes("Revenue")
                                    ? { color: "green" }
                                    : null
                              }
                            >
                              {item[Object.keys(item)][0].unit === "money"
                                ? `$${item[Object.keys(item)][0].City.toFixed(
                                    2
                                  ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                                : item[Object.keys(item)][0].unit === "percent"
                                  ? `${item[Object.keys(item)][0].City.toFixed(
                                      2
                                    ).replace(
                                      /(\d)(?=(\d{3})+(?!\d))/g,
                                      "$1,"
                                    )}%`
                                  : item[Object.keys(item)][0].unit === "number"
                                    ? `${item[
                                        Object.keys(item)
                                      ][0].City.toFixed(2).replace(
                                        /(\d)(?=(\d{3})+(?!\d))/g,
                                        "$1,"
                                      )} ${
                                        Object.keys(item)
                                          .toString()
                                          .includes("PM")
                                          ? "µg/m³"
                                          : Object.keys(item)
                                              .toString()
                                              .includes("CO2")
                                            ? "T"
                                            : ""
                                      }`
                                    : item[Object.keys(item)][0].City}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      maxWidth: "50%",
                      height: "58vh",
                      border: "solid 2px slategrey",
                      borderRadius: "29px",
                      padding: "10px",
                      position: "relative",
                    }}
                  >
                    <div className="dropdown">
                      <select
                        className="plotSelect"
                        name="selectedMetric1"
                        value={this.state.selectedMetric1}
                        onChange={(e) => this.onPlotChange1(e)}
                        id="selectedMetric1"
                      >
                        {this.state.selectionAvailable ? (
                          <Fragment>
                            <option>Please select Data for Review</option>
                            <optgroup label="---Metrics---">
                              {this.state.metricsSelections.map(
                                (item, index) => (
                                  <option
                                    key={index}
                                    value={item}
                                    name="selectedMetric1"
                                  >
                                    {item}
                                  </option>
                                )
                              )}
                            </optgroup>
                            <optgroup label="---Costs---">
                              {this.state.costSelections.map((item, index) => (
                                <option
                                  key={index}
                                  value={item}
                                  name="selectedMetric1"
                                >
                                  {item}
                                </option>
                              ))}
                            </optgroup>
                            <optgroup label="---Revenue---">
                              {this.state.revenueSelections.map(
                                (item, index) => (
                                  <option
                                    key={index}
                                    value={item}
                                    name="selectedMetric1"
                                  >
                                    {item}
                                  </option>
                                )
                              )}
                            </optgroup>
                          </Fragment>
                        ) : (
                          <option>Gathering Selections...</option>
                        )}
                      </select>
                    </div>
                    {this.state.plotType1 === "city" ||
                    this.state.plotType1 === "citycost" ||
                    this.state.plotType1 === "cityrevenue" ? (
                      <ResponsiveContainer width={"99%"} height="91%">
                        <LineChart
                          data={dynamicPlotData}
                          margin={{ top: 30, right: 10, left: 25, bottom: 5 }}
                        >
                          <CartesianGrid
                            stroke={plotColor}
                            strokeDasharray="3 3"
                          />
                          <XAxis stroke={plotColor} dataKey="year" />
                          <YAxis stroke={plotColor} />
                          <Tooltip
                            formatter={(value) =>
                              new Intl.NumberFormat("en").format(value)
                            }
                          />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="City"
                            stroke="#5399C9"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Forecasted City"
                            stroke="#FF5733"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    ) : null}
                    {this.state.plotType1 === "district" ||
                    this.state.plotType1 === "districtcost" ||
                    this.state.plotType1 === "districtrevenue" ? (
                      <ResponsiveContainer width={"100%"} height="91%">
                        <LineChart
                          data={dynamicPlotData}
                          margin={{ top: 30, right: 10, left: 25, bottom: 5 }}
                        >
                          <CartesianGrid
                            stroke={plotColor}
                            strokeDasharray="3 3"
                          />
                          <XAxis stroke={plotColor} dataKey="year" />
                          <YAxis stroke={plotColor} />
                          <Tooltip
                            formatter={(value) =>
                              new Intl.NumberFormat("en").format(value)
                            }
                          />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="Corbusville"
                            stroke="#80B43A"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Downtown"
                            stroke="#5399C9"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="HowardGardens"
                            stroke="#FF6302"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="JacobsHill"
                            stroke="#FECE00"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="MosesGulch"
                            stroke="#DF344A"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Forecasted Corbusville"
                            stroke="#6E3AB4"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted Downtown"
                            stroke="#FF5733"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted HowardGardens"
                            stroke="#6302FF"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted JacobsHill"
                            stroke="#00FECE"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted MosesGulch"
                            stroke="#344ADF"
                            strokeWidth="5px"
                            dot={false}
                            strokeDasharray="10 5"
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    ) : null}
                    {this.state.plotType1 === "transportation" ? (
                      <ResponsiveContainer width={"99%"} height="91%">
                        <LineChart
                          data={dynamicPlotData}
                          margin={{ top: 30, right: 10, left: 25, bottom: 5 }}
                        >
                          <CartesianGrid
                            stroke={plotColor}
                            strokeDasharray="3 3"
                          />
                          <XAxis stroke={plotColor} dataKey="year" />
                          <YAxis stroke={plotColor} />
                          <Tooltip
                            formatter={(value) =>
                              new Intl.NumberFormat("en").format(value)
                            }
                          />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="Car"
                            stroke="#5399C9"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Rail"
                            stroke="#FF6302"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Bus"
                            stroke="#FECE00"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Walk"
                            stroke="#DF344A"
                            strokeWidth="5px"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Bike"
                            stroke="#80B43A"
                            strokeWidth="5px"
                            dot={false}
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted Walk"
                            stroke="#344ADF"
                            strokeWidth="5px"
                            strokeDasharray="10 5"
                            dot={false}
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted Car"
                            stroke="#99C953"
                            strokeWidth="5px"
                            strokeDasharray="10 5"
                            dot={false}
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted Rail"
                            stroke="#02FF63"
                            strokeWidth="5px"
                            strokeDasharray="10 5"
                            dot={false}
                          />

                          <Line
                            type="monotone"
                            dataKey="Forecasted Bus"
                            stroke="#CE00FE"
                            strokeWidth="5px"
                            strokeDasharray="10 5"
                            dot={false}
                          />
                          <Line
                            type="monotone"
                            dataKey="Forecasted Bike"
                            stroke="#3A80B4"
                            strokeWidth="5px"
                            strokeDasharray="10 5"
                            dot={false}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    ) : null}
                  </div>
                </div>
              </div>
            </ReactCSSTransitionGroup>
            {/* // {!this.state.city.is_complete ? (
              //   this.state.city.has_started ? (
              //     <button
              //       className="button loginBtn"
              //       onClick={e => this.advanceScenario(e)}
              //       disabled={this.state.advanceRequestSent ? "disabled" : ""}
              //     >
              //       {this.state.advanceRequestSent
              //         ? "Advancing . . ."
              //         : "Advance"}
              //     </button>
              //   ) : (
              //     <button
              //       className="button loginBtn"
              //       onClick={e => this.startScenario(e)}
              //       disabled={this.state.startRequestSent ? "disabled" : ""}
              //     >
              //       {this.state.startRequestSent
              //         ? "Starting . . ."
              //         : "Start Scenario"}
              //     </button>
              //   )
              // ) : null}
              // <button
              //   className="button logoutBtn resetScenario"
              //   onClick={e => this.resetScenario(e)}
              //   disabled={this.state.resetRequestSent ? "disabled" : ""}
              // >
              //   {this.state.resetRequestSent
              //     ? "Resetting . . ."
              //     : "Reset Scenario"}
              // </button> */}
          </Fragment>
        ) : null}
        <Footer />
      </div>
    );
  }
}

export default withRouter(CityControlPanel);
